module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('el-row', {
    staticClass: "gPageBorder  gPdTB"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.certificateName')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.certinfo.certificateName) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.createTime')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.certinfo.createTime) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.zdqds')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.certinfo.distributorName) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.remark')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.certinfo.certificateDesc) + "\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gTopMg gPageBorder"
  }, [_c('p', {
    staticClass: "gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.xiafalishi')))]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.arrdata,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "operationTime",
      "label": _vm.$t('lin_global.time')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "merchantName",
      "label": _vm.$t('lin_global.label_areaid')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "successQuantity",
      "label": _vm.$t('lin_global.chenggong')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "failQuantity",
      "label": _vm.$t('lin_global.shibai')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('lin_global.ope')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_global.resXiafa'),
            "placement": "top"
          }
        }, [(scope.row.operateAgain == '1') ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.resXiafa(scope.row.id, scope.row.merchantId, scope.row.opearationType, scope.row.pushtype, scope.row.certificateid)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })]) : _vm._e()], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 50, 100],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b3b4fa30"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/safe/certDetail.vue
// module id = 1117
// module chunks = 0